import { Link } from "react-router-dom";
import Ico from "../components/Icons";
import useReveal from "../hooks/useReveal";

const TICKERS = ["Digitalisation","Développement Web","Maintenance IT","Google Business","Marketing Digital","Logiciel de Gestion","Automatisation","Transformation Digitale"];

const STEPS = [
  { n:"01", t:"Écoute & audit",        d:"On prend le temps de comprendre votre métier, vos contraintes et vos objectifs avant de proposer quoi que ce soit." },
  { n:"02", t:"Stratégie sur-mesure",  d:"On définit ensemble le plan d'action le plus rentable : site, gestion, visibilité ou pack complet selon vos priorités." },
  { n:"03", t:"Réalisation",           d:"Nos équipes développent, conçoivent et configurent vos outils avec des points d'étape réguliers pour valider chaque avancée." },
  { n:"04", t:"Suivi & optimisation",  d:"Une fois lancé, on reste présents : maintenance, ajustements et conseils pour que vos outils continuent de vous faire gagner." },
];

const TESTIMONIALS = [
  { name:"Aïssatou Diallo", role:"Gérante, Boutique Mode Dakar", init:"AD", quote:"Layetech a complètement changé notre façon de vendre en ligne. La boutique tourne toute seule et les clients nous trouvent facilement sur Google." },
  { name:"Moussa Fall", role:"Fondateur, Restaurant Le Black&White", init:"MF", quote:"L'application de commande et la caisse tactile nous ont fait gagner un temps fou en salle. L'équipe a été disponible du premier jour au dernier." },
  { name:"Khady Sarr", role:"Directrice, Cabinet de Conseil", init:"KS", quote:"Le suivi mensuel et le reporting nous permettent enfin de savoir ce qui marche vraiment dans notre communication. Très pro, très réactifs." },
];

export default function Home() {
  useReveal();

  return (
    <>
      {/* HERO */}
      <section className="hero" id="hero">
        <div className="hgrid" />
        <div className="hblob hb1" />
        <div className="hblob hb2" />
        <div className="hinner">
          <div>
            <div className="htag"><span className="hdot" />Dakar · Sénégal · Innovation Digitale</div>
            <h1 className="hh1">Nous digitalisons<span className="hl2">votre business.</span></h1>
            <p className="hsub">Technologie, gestion, visibilité et innovation réunies en un seul partenaire pour faire grandir votre entreprise, quel que soit votre secteur d'activité.</p>
            <div className="hctas">
              <Link className="btnf" to="/contact?sujet=devis">Demander un devis <span className="arr"><Ico name="arrowR" size={15} color="#fff" /></span></Link>
              <Link className="btno" to="/services">Voir nos services</Link>
            </div>
          </div>
          <div className="hright">
            <div className="fbadge fbt"><span className="fbdot" />+50 clients actifs</div>
            <div className="hcard">
              <div className="hcard-top">
                <div className="hcard-av"><Ico name="barChart" size={20} color="#fff" /></div>
                <div>
                  <div className="hcard-lbl">Tableau de bord</div>
                  <div className="hcard-name">Layetech Analytics</div>
                </div>
              </div>
              <div className="hm-grid">
                {[["98%", "Satisfaction", 88], ["×3", "Croissance", 72], ["48h", "Délai livraison", 92], ["100%", "Accompagnement", 100]].map(([v, l, p]) => (
                  <div className="hm" key={l}>
                    <div className="hm-val">{v}</div>
                    <div className="hm-lbl">{l}</div>
                    <div className="hm-bar"><div className="hm-fill" style={{ width: `${p}%` }} /></div>
                  </div>
                ))}
              </div>
            </div>
            <div className="fbadge fbb"><Ico name="shield" size={13} color="var(--blue-m)" />Partenaire certifié Google</div>
          </div>
        </div>
      </section>

      {/* TICKER */}
      <div className="ticker">
        <div className="tickinner">
          {[...TICKERS, ...TICKERS].map((t, i) => (
            <div className="tickitem" key={i}>{t}<span className="ticksep">✦</span></div>
          ))}
        </div>
      </div>

      {/* PROBLÈME / SOLUTION */}
      <section className="sec" id="solutions" style={{ background: "var(--off)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Le constat</div>
            <h2 className="sh2">Votre commerce <em>mérite mieux.</em></h2>
            <p className="slead">Trop d'entreprises locales perdent des clients faute de présence digitale, d'outils de gestion adaptés ou d'une stratégie claire. Résultat : des heures perdues, des ventes manquées, et une concurrence qui prend l'avantage. Layetech change ça, étape par étape.</p>
          </div>
          <div className="psgrid r" style={{ transitionDelay: ".1s" }}>
            <div className="pscol">
              {[["xmark", "Aucune visibilité en ligne"], ["xmark", "Gestion manuelle & erreurs"], ["xmark", "Image non professionnelle"], ["xmark", "Clients perdus chez la concurrence"], ["xmark", "Zéro stratégie digitale"]].map(([ico, txt], i) => (
                <div className="psc" key={i} style={{ transitionDelay: `${i * .05}s`, borderColor: "rgba(220,38,38,.12)" }}>
                  <span className="psico bad"><Ico name={ico} size={15} color="#dc2626" /></span>
                  <span>{txt}</span>
                </div>
              ))}
            </div>
            <div className="psarr">
              <div className="psarrline" />
              <Ico name="arrowR" size={18} color="var(--blue-m)" />
              <div className="psarrline" />
            </div>
            <div className="pscol">
              {[["check", "Présence digitale 360°"], ["check", "Outils de gestion modernes"], ["check", "Branding professionnel"], ["check", "Clients attirés & fidélisés"], ["check", "Accompagnement stratégique"]].map(([ico, txt], i) => (
                <div className="psc" key={i} style={{ transitionDelay: `${i * .05 + .25}s`, borderColor: "rgba(22,163,74,.15)" }}>
                  <span className="psico good"><Ico name={ico} size={15} color="#16a34a" /></span>
                  <span>{txt}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* PROCESSUS */}
      <section className="sec" style={{ background: "var(--w)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Notre méthode</div>
            <h2 className="sh2">Comment nous <em>travaillons</em></h2>
            <p className="slead">Un processus simple et transparent, du premier échange jusqu'au suivi sur le long terme. Pas de jargon, pas de surprises.</p>
          </div>
          <div className="stepgrid">
            {STEPS.map((s, i) => (
              <div className="stepc r" key={s.n} style={{ transitionDelay: `${i * .08}s` }}>
                <div className="stepnum">{s.n}</div>
                <div className="stept">{s.t}</div>
                <p className="stepd">{s.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TÉMOIGNAGES */}
      <section className="sec" style={{ background: "var(--off)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Ils nous font confiance</div>
            <h2 className="sh2">Ce que disent <em>nos clients</em></h2>
            <p className="slead">Des commerçants et entrepreneurs sénégalais qui ont fait le pas du digital avec Layetech.</p>
          </div>
          <div className="testigrid">
            {TESTIMONIALS.map((t, i) => (
              <div className="testic r" key={t.name} style={{ transitionDelay: `${i * .08}s` }}>
                <div className="testistars">
                  {Array.from({ length: 5 }).map((_, j) => <Ico key={j} name="sparkle" size={13} color="var(--cyan)" />)}
                </div>
                <p className="testiquote">« {t.quote} »</p>
                <div className="testiauth">
                  <div className="testiav">{t.init}</div>
                  <div>
                    <div className="testiname">{t.name}</div>
                    <div className="testirole">{t.role}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="ctaband r" style={{ transitionDelay: ".2s" }}>
            <div>
              <h3>Prêt·e à faire grandir votre business ?</h3>
              <p>Parlons de votre projet : le premier échange est gratuit et sans engagement, et vous repartez avec des pistes concrètes.</p>
            </div>
            <Link className="ctabtn" to="/contact?sujet=projet">Discuter de mon projet <Ico name="arrowR" size={15} color="var(--blue)" /></Link>
          </div>
        </div>
      </section>
    </>
  );
}